import React from 'react';
import Spinner from '@atlaskit/spinner';
import { asyncPopupSelectMessages } from './messages';
import CustomSelectMessage from './selectMessage';
var CustomDropdownLoadingMessage = function CustomDropdownLoadingMessage(_ref) {
  var filterName = _ref.filterName;
  return /*#__PURE__*/React.createElement(CustomSelectMessage, {
    icon: /*#__PURE__*/React.createElement(Spinner, {
      size: "large"
    }),
    message: asyncPopupSelectMessages.loadingMessage,
    testId: "".concat(filterName, "--loading-message")
  });
};
export default CustomDropdownLoadingMessage;